import { RequestResetPasswordDto, SetPasswordDto } from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';


const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/password-reset`;

export const validateToken = (token: string, source: CancelTokenSource): Promise<string> => {
  return axios
      .get(`${apiUri}`,{params:{ token: token}, cancelToken: source.token})
      .then(response => response.data);
};

export const requestPasswordReset = (requestResetPasswordDto: RequestResetPasswordDto,
                                     source: CancelTokenSource): Promise<string> => {
  return axios
      .post(apiUri, requestResetPasswordDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const resetPassword = (token: string, setPasswordDto: SetPasswordDto,
                              source: CancelTokenSource): Promise<string> => {
  return axios
      .put(`${apiUri}`, setPasswordDto, {params:{token: token}, cancelToken: source.token})
      .then(response => response.data);
};
